export interface EventWizardDescriptionProps {
  // add props here
}

export interface AiGeneratedDescriptionParams {
  type: string;
  name: string;
  venue?: string;
  date: string;
  timing: string;
  description: string;
}

export const MAX_EVENT_DESCRIPTION_LENGTH = 5000;